<template>
	<div>
		<!-- 제휴문의 팝업 -->
		<div class="counsel_pop" :class="{'full_pop': this.full}">
			<a class="counsel_pop_close" @click="closeCounsel"><img src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png"/></a>
			<div class="wrapper">
				<div class="title_line">
					<div class="tit">B2B 교육·제휴 문의</div>
					<div class="comm">문의 내용을 작성해 주세요. 빠른 검토 후 연락 드리겠습니다.</div>
				</div>
				<form>
					<div class="counsel_contents">
						<div class="group">
							<div class="group_tit">문의내용
								<div class="tit"><span class="red">*</span> 필수 작성항목</div>
							</div>
							<div class="group_sec">
								<div class="tit">
									<span>사업분야</span>
									<span class="red">*</span>
									<span class="group_num">{{telNo}}</span>
								</div>
								<div class="con">
									<div class="radio_group radio_business">
										<div class="radio_box">
											<input v-model="info.bizCd" type="radio" class="def" align="absmiddle"
											       id="tips01" value="01"><label
											for="tips01"><span>기업·공공기관 교육</span></label>
										</div>
										<div class="radio_box">
											<input v-model="info.bizCd" type="radio" class="def" align="absmiddle"
											       id="tips02" value="02"><label
											for="tips02"><span>대학·특성화고 교육</span></label>
										</div>
										<div class="radio_box">
											<input v-model="info.bizCd" type="radio" class="def" align="absmiddle"
											       id="tips03" value="05"><label
											for="tips03"><span>콘텐츠 제휴</span></label>
										</div>
									</div>
								</div>
							</div>
							<div class="row-box">
								<div class="group_sec col-2">
									<div class="tit">
										<span>기관명</span>
										<span class="red">*</span>
									</div>
									<div class="con">
										<input type="text" class="form_control" ref="companyNm" v-model="info.companyNm"
										       placeholder="기관명을 입력해주세요." maxlength="50">
									</div>
								</div>
								<div class="group_sec col-2">
									<div class="tit">
										<span>제목</span>
										<span class="red">*</span>
									</div>
									<div class="con">
										<input type="text" class="form_control" ref="mailTitle" v-model="info.mailTitle"
										       placeholder="제목을 입력해주세요." maxlength="50">
									</div>
								</div>
							</div>
							<div class="group_sec">
								<div class="tit">
									<span>내용</span>
									<span class="red">*</span>
								</div>
								<div class="con">
									<textarea class="form_control" ref="mailContent" v-model="info.mailContent"
									          placeholder="내용을 입력해주세요."></textarea>
								</div>
							</div>
							<div class="group_sec">
								<div class="tit">
									<span>첨부파일</span>
								</div>
								<div class="con">
									<div class="filebox">
										<input v-model="info.filename" class="form_control upload-name"
										       placeholder="파일을 선택하세요" disabled="disabled">
										<label for="ex_filename">파일선택</label>
										<input type="file" ref="attachFile" @change="handleFileChange"
										       id="ex_filename" class="upload-hidden">
									</div>
									<div class="desc">* 파일용량은 최대 10MB이며, 파일은 PDF, PPT, PPTX, 엑셀, 워드형식만 가능합니다.</div>
								</div>
							</div>
						</div>
						<div class="group">
							<div class="group_tit">답변 받으실 연락처</div>
							<div class="row-box">
								<div class="group_sec col-3">
									<div class="tit">
										<span>이름</span>
										<span class="red">*</span>
									</div>
									<div class="con">
										<input type="text" class="form_control" ref="sendNm" v-model="info.sendNm"
										       placeholder="이름을 입력해주세요." maxlength="50">
									</div>
								</div>
								<div class="group_sec col-3">
									<div class="tit">
										<span>연락처</span>
										<span class="red">*</span>
									</div>
									<div class="con">
										<input type="text" class="form_control" ref="hp" v-model="info.hp"
										       placeholder="연락처를 입력해주세요." maxlength="50">
									</div>
								</div>
								<div class="group_sec col-3">
									<div class="tit">
										<span>메일주소</span>
										<span class="red">*</span>
									</div>
									<div class="con">
										<input type="text" class="form_control" ref="sendMailAddress"
										       v-model="info.sendMailAddress" placeholder="메일주소를 입력해주세요."
										       maxlength="50">
									</div>
								</div>
							</div>
						</div>
						<div class="group">
							<div class="group_tit noline">개인정보 수집 및 이용동의</div>
							<div class="agree_box">
								<ul>
									<li><span class="bd">수집항목</span> : 기관명, 이름, 연락처, 이메일 및 작성 내용에 포함된 개인정보</li>
									<li><span class="bd">수집 및 이용 목적</span> : 상담 내역 확인과 답변 처리, 고객사 관리</li>
									<li><span class="bd">보유 및 이용 기간</span> : <strong>상담 신청 후 1년</strong></li>
								</ul>
							</div>
							<div class="check_group">
								<div class="check_box">
									<input type="checkbox" ref="chk" v-model="info.chk" class="def" align="absmiddle"
									       id="chk_agree"><label for="chk_agree"> <span>개인정보 수집 및 이용에 동의합니다.</span>
								</label>
								</div>
							</div>
						</div>
					</div>
				</form>
				<div class="btn_area">
					<a class="btn_form_counsel" @click="registB2bEdw">문의하기</a>
				</div>
			
			</div>
		</div>
	
	</div>
</template>

<script>
import eventBus from "@/eventBus/event-bus";
export default {
	name: "CounselModal",
	
	data() {
		return {
			info: {
				bizCd: "01",
				companyNm: "",
				mailTitle: "",
				mailContent: "",
				sendNm: "",
				hp: "",
				sendMailAddress: "",
				chk: false,
				attachFile: "",
				filename: ""
			},
			full: false,
		}
	},
	
	computed: {
		telNo() {
			return this.info.bizCd == "01" ? "02-397-0187" : (this.info.bizCd == "02" ? "02-2650-3976" : "02-2650-3972");
		}
	},
	
	methods: {
		showCounsel(v, t) {
			/*
			this.info.bizCd = v||"01";
			if ( window.innerWidth < 1100 ) {
				t==='full'?this.full=true:this.full=false;
			} else {
				this.full = false;
			}
			$('.counsel_pop').bPopup();
			*/

			if (process.env.VUE_APP_MODE == 'PRODUCTION' ) {
				window.open("https://company.eduwill.net/consulting/partnershipPopup");
			} else {
				window.open("https://s-company.eduwill.net/consulting/partnershipPopup");
			}
		},
		closeCounsel() {
			this.full = false;
			$('.counsel_pop').bPopup().close();
		},
		handleFileChange(e) {
			this.info.filename = e.target.files[0].name
			this.info.attachFile = this.$refs.attachFile.files[0];
		},
		async registB2bEdw() {
			//제목
			if (this.info.companyNm == "") {
				alert("기관명을 입력해주세요.");
				this.$refs.companyNm.focus();
			} else if (this.info.mailTitle == "") {
				alert("제목을 입력하세요.");
				this.$refs.mailTitle.focus();
			} else if (this.info.mailContent == "") {
				alert("내용을 입력하세요.");
				this.$refs.mailContent.focus();
			} else if (this.info.sendNm == "") {
				alert("이름을 입력해주세요");
				this.$refs.sendNm.focus();
			} else if (this.info.hp == "") {
				alert("연락처를 입력하세요.");
				this.$refs.hp.focus();
			} else if (this.info.sendMailAddress == "") {
				alert("메일주소를 입력하세요.");
				this.$refs.sendMailAddress.focus();
			} else if (!this.info.chk) {
				alert('약관에 동의해 주세요');
				this.$refs.chk.focus();
			} else {
				const frm = new FormData();
				frm.append("bizCd", this.info.bizCd);
				frm.append("companyNm", this.info.companyNm);
				frm.append("mailTitle", this.info.mailTitle);
				frm.append("mailContent", this.info.mailContent);
				frm.append("sendNm", this.info.sendNm);
				frm.append("hp", this.info.hp);
				frm.append("sendMailAddress", this.info.sendMailAddress);
				frm.append("attachFile", this.info.attachFile);
				
				const data = await this.$mapi('/upload/insertSendEmail', frm);
				if ( data.result > 0 ) {
					alert("등록 되었습니다.");
					this.closeCounsel();
				} else {
					alert("등록을 실패하였습니다.");
					this.closeCounsel();
				}
			}
		}
	},
	
	created() {
		eventBus.$on("show-counsel", (v, t)=>{
			this.showCounsel(v, t);
		});
	},
	beforeMount() {
	},
	mounted() {
	},
}
</script>

<style scoped>
	.full_pop {
		width: 100%;
		left: 0px !important;
		top: 0px !important;
		max-height: 100%;
	}
</style>
